export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00593.156ec537.png";